import { formatHtml } from "@trumpf/ux.common-storybook";
import { exampleSlot, Template } from "./registration-page.templates";

export default {
    title: "Salesforce/Pages/Registration Page",
    component: "ux-iws-sf-page",
    render: Template.bind({}),
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        variant: {
            control: {
                type: "select",
                options: ["", "center-blue"],
            },
        },
        _slot: {
            control: { type: "text" },
        },
    },
    args: {
        className: "ux-t-container-full",
        variant: "center-blue",
        _slot: exampleSlot,
    },
};

export const RegistrationPage = {};
